import React, { useEffect, useMemo } from "react";
import { useHistory } from "react-router-dom";

import { useMastersContext } from "../../../../contexts/masters.context";
import DecoMethodService from "../../../../services/DecoMethodService";
import CrudTable from "../../shared/table/CrudTable";
import { TABLE_COLUMNS } from "./models/decoMethodsTableColumns";

function DecoMethodsTable() {
  const history = useHistory();
  const { decoMethodsState, colorPricingCategoryState } = useMastersContext();

  useEffect(() => {
    decoMethodsState.fetch();
    colorPricingCategoryState.fetch();
  }, []);

  const columns = useMemo(() => TABLE_COLUMNS, [TABLE_COLUMNS]);
  const data = useMemo(() => decoMethodsState.data, [decoMethodsState.data]);

  const removeDecoMethod = async (id) => {
    if (window.confirm("Are you sure ?") === true) {
      const result = await DecoMethodService.remove(id);
      if (result.success === true) {
        decoMethodsState.fetch();
      }
    }
  };

  return (
    <div>
      <div className="row">
        <div className="col"></div>
        <div className="col">
          <h4>Deco Methods</h4>
        </div>
        <div className="col d-flex justify-content-end">
          <button
            className="btn btn-sm btn-success"
            onClick={() => history.push("/masters/deco-methods/add")}
          >
            Add New
          </button>
        </div>
      </div>
      <hr />
      <CrudTable
        loading={decoMethodsState.loading}
        data={data || []}
        columns={columns}
        idField="dM_ID"
        onEdit={(id) => history.push(`/masters/deco-methods/edit/${id}`)}
        onRemove={(id) => removeDecoMethod(id)}
      />
    </div>
  );
}

export default DecoMethodsTable;
